var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefreshButtonGarage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8099 13.7704L17.975 13.2166C17.5127 13.0721 17.0022 13.284 16.8048 13.7223C16.2413 14.9696 15.2878 15.9953 14.0597 16.6503C11.0161 18.2732 7.2116 17.1174 5.58385 14.0786C3.96091 11.035 5.11671 7.23051 8.15551 5.60275C9.98072 4.62995 12.0852 4.62995 13.8478 5.49681L12.7498 6.59482C12.1478 7.20162 12.5765 8.23702 13.4337 8.23702H18.813C19.3475 8.23702 19.7761 7.80841 19.7761 7.27385V1.89455C19.7761 1.03733 18.7407 0.608722 18.1339 1.21552L16.6651 2.67954C13.6119 0.661696 9.68213 0.420904 6.33994 2.20277C1.42777 4.83222 -0.435959 10.9724 2.18386 15.8942C4.00907 19.299 7.51019 21.2398 11.1269 21.2398C12.7354 21.2398 14.3631 20.8545 15.8753 20.0503C17.9461 18.9378 19.5354 17.1849 20.4263 15.0466C20.6478 14.5265 20.3492 13.9342 19.8099 13.7704Z",
    fill: "#003752"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshButtonGarage);
export default __webpack_public_path__ + "static/media/refreshButtonGarage.92a659c3fd19fb75acb6cc0309ee000d.svg";
export { ForwardRef as ReactComponent };